import React, { useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai';

import Text from '@/components/common/Text';

import * as S from './style';

interface PageHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  width?: string;
  zIndex?: number;
}

const PageHelpModal = ({
  isOpen,
  onClose,
  title,
  children,
  width = '40rem',
  zIndex = 1000,
}: PageHelpModalProps) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <S.Background zIndex={zIndex}>
      <S.Overlay onClick={onClose} />
      <S.ModalContainer width={width}>
        <S.CloseWrapper>
          <Text fontSize='1.375rem' fontWeight={700}>
            {title}
          </Text>
          <AiOutlineClose
            onClick={onClose}
            size='1.5rem'
            style={{ cursor: 'pointer' }}
          />
        </S.CloseWrapper>
        <S.Body>{children}</S.Body>
      </S.ModalContainer>
    </S.Background>
  );
};

export default PageHelpModal;
